import React, { useContext } from "react";
import { useLocation, Routes, Route, Navigate } from "react-router-dom";
import FinancialReport from "./FinancialReport";
import PayslipWithSelector from "../Payslip/PayslipWithSelector";
import Salary from "./Salary";
import AccountCard3350, {
  hasAccountCardAccess,
} from "./AccountCard3350/AccountCard3350";
import SubHeader from "../Subheader/Subheader";
import { UserContext } from "../../contexts/CurrentUserContext";
import "./FinancialReportTabs.css";

function FinancialReportTabs() {
  const location = useLocation();
  const { userData } = useContext(UserContext);
  const isPayslipTab = location.pathname.includes("payslip");
  const canViewAccountCard = hasAccountCardAccess(userData);

  const tabs = [
    {
      id: "report",
      label: "ОТЧЕТ ПО СОТРУДНИКАМ",
      path: "employee",
    },
    {
      id: "payslip",
      label: "РАСЧЕТНЫЕ ЛИСТЫ",
      path: "payslip",
    },
    {
      id: "salary",
      label: "ЗАРАБОТНАЯ ПЛАТА",
      path: "salary",
    },
    canViewAccountCard && {
      id: "account-3350",
      label: "КАРТОЧКА СЧЕТА 3350",
      path: "account-3350",
    },
  ].filter(Boolean);

  return (
    <div className="financial-report-tabs">
      <SubHeader tabs={tabs} showRefreshButton={isPayslipTab} />
      <div className="financial-report-tabs__content">
        <Routes>
          <Route path="employee" element={<FinancialReport />} />
          <Route
            path="payslip"
            element={<PayslipWithSelector showSelector={true} />}
          />
          <Route path="salary" element={<Salary />} />
          <Route
            path="account-3350"
            element={
              canViewAccountCard ? (
                <AccountCard3350 />
              ) : (
                <Navigate to="../employee" replace />
              )
            }
          />
          <Route path="/" element={<Navigate to="employee" replace />} />
        </Routes>
      </div>
    </div>
  );
}

export default FinancialReportTabs;
